<template>
  <div class="organic-matter-field">
    <n-input-select
      name="fertilizer"
      class="product"
      :label="$t('type')"
      type="vertical"
      :value="application.fertilizer"
      :options="fertilizers"
      @change="handleValueChange" />
    <n-input-number
      name="rate"
      class="n-rate"
      :label="$t('n-rate')"
      type="vertical"
      unit="kg/ha"
      min="0"
      :value="application.rate"
      @change="handleValueChange" />
    <n-input-date
      name="date"
      :label="$t('application-date')"
      :value="date"
      @change="handleValueChange" />
  </div>
</template>

<style lang="scss" scoped>

.organic-matter-field {
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  grid-gap: $spacing--xs;

  .n-rate {
    width: 5rem;
  }

  .product {
    width: 10rem;
  }
}

</style>

<script>
import moment from 'moment'

import InputSelect from '@/components/InputSelect'
import InputDate from '@/components/InputDate'
import InputNumber from '@/components/InputNumber'

export default {
  components: {
    'n-input-select': InputSelect,
    'n-input-date': InputDate,
    'n-input-number': InputNumber
  },
  props: {
    application: {
      type: Object
    },
    fertilizers: {
      type: Array
    }
  },
  computed: {
    date () {
      return moment(this.application.date).format('YYYY-MM-DD')
    }
  },
  methods: {
    handleValueChange (e) {
      const { name, type } = e.target
      let value = e.target.value
      if (type === 'date') {
        value = e.target.valueAsDate
      } else if (type === 'number') {
        value = e.target.valueAsNumber
      }
      this.$emit('change', {
        name,
        value
      })
    }
  }
}
</script>
